<template>
  <div style="position: relative">
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <div v-if="loading" class="loading-overlay"></div>
    <div class="d-flex justify-content-between align-items-center">
      <h3>
        <feather-icon size="23" icon="GitBranchIcon" />
        المراكز الخدمية
      </h3>
      <b-button
        variant="success"
        @click="newCentreModal = true"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <feather-icon size="15" class="mr-25" icon="PlusIcon" />
        إضافة مركز
      </b-button>
    </div>
    <hr />

    <app-collapse v-if="centres.length > 0" accordion>
      <service-centre-collapse
        v-for="centre in centres"
        :key="centre.id"
        :title="centre.name"
        :status="centre.status"
        @editClicked="openEditCentreModal(centre)"
        @deleteClicked="onDeleteCentre(centre.id)"
      >
        <b-row class="w-100">
          <b-col cols="6">
            <info-card label="اسم المركز" :value="centre.name" />
          </b-col>
          <b-col cols="6">
            <info-card
              label="نوع المركز"
              :value="centre.serviceCentreType.name"
            />
          </b-col>
          <b-col cols="6">
            <info-card
              label="حالة المركز"
              :value="centre.status ? 'فعال' : 'متوقف'"
            />
          </b-col>

          <b-col cols="6">
            <info-card
              label="رقم قرار الترخيص"
              :value="centre.clearance_decision_number"
            />
          </b-col>
          <b-col cols="6">
            <info-card
              label="رقم العقار"
              :value="centre.realEstate ? centre.realEstate.number : ''"
            />
          </b-col>
          <b-col cols="6" v-if="centre.clearanceAuthority">
            <info-card
              label="الجهة المرخصة"
              :value="centre.clearanceAuthority.name"
            />
          </b-col>
          <b-col cols="6">
            <info-card label="العنوان التفصيلي" :value="centre.address" />
          </b-col>
        </b-row>
      </service-centre-collapse>
    </app-collapse>
    <div v-else>
      <div class="text-center p-1" style="opacity: 0.6">
        <h5 class="text-warning">
          <feather-icon class="mx-25" icon="AlertTriangleIcon" />

          لا يوجد سجلات حتى الآن
        </h5>
      </div>
    </div>

    <service-centre-modal
      @confirm="onNewCentre"
      :loading="working"
      v-model="newCentreModal"
    />
    <service-centre-modal
      @confirm="onUpdateCentre"
      :loading="working"
      ref="editCentreModal"
      v-model="editCentreModal"
      :intializeForm.sync="editCentreForm"
    />
  </div>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BButton } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
import ServiceCentreModal from "../../components/ServiceCentreModal.vue";
import { BRow, BCol } from "bootstrap-vue";
import formAutocomplete from "@/components/form-autocomplete";
import ServiceCentreCollapse from "../../components/ServiceCentreCollapse.vue";
export default {
  components: {
    BButton,
    ServiceCentreCollapse,
    AppCollapse,
    AppCollapseItem,
    InfoCard,
    BRow,
    ServiceCentreModal,
    BCol,
    formAutocomplete,
  },
  data() {
    return {
      editCentreForm: {},
      editCentreModal: false,
      newCentreModal: false,
      mainInfo: {},
    };
  },
  methods: {
    ...mapActions("NgoProfile/ServiceCentre", [
      "getCentres",
      "addNewCentre",
      "updateCentre",
      "deleteCentre",
    ]),

    clearId(val) {
      var x = JSON.parse(JSON.stringify(val));

      delete x.id;
      x.area = x.area.name;

      return x;
    },
    async onNewCentre(payload) {
      await this.addNewCentre(payload);
      this.newCentreModal = false;
    },
    async onUpdateCentre(payload) {
      await this.updateCentre(payload);
      this.editCentreModal = false;
    },
    async onDeleteCentre(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المركز", {
          title: "تأكيد حذف مركز",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteCentre(id);
          }
        });
    },
    openEditCentreModal(centre) {
      this.editCentreForm = JSON.parse(
        JSON.stringify({
          id: centre.id,
          name: centre.name,
          service_centre_type_id: centre.serviceCentreType.id,
          clearance_decision_number: centre.clearance_decision_number,
          longitude: centre.area.longitude,
          latitude: centre.area.latitude,
          status: centre.status,
          clearance_authority_id: centre.clearanceAuthority
            ? centre.clearanceAuthority.id
            : null,
          area_id: centre.area.id,
          address: centre.address,
          real_estate_id: centre.realEstate ? centre.realEstate.id : null,
          area: centre.area,
        })
      );
      this.$refs.editCentreModal.init(this.editCentreForm);
      this.editCentreModal = true;
    },
  },

  computed: {
    ...mapGetters("NgoProfile", ["ngoData"]),
    ...mapGetters("NgoProfile/ServiceCentre", [
      "centres",
      "loading",
      "working",
    ]),
  },
  mounted() {
    this.mainInfo = {
      name: {
        label: "اسم المركز",
      },
      serviceCentreType: {
        label: "نوع المركز",
      },
      clearance_decision_number: {
        label: "رقم قرار الترخيص",
      },
      clearanceAuthority: {
        label: "المحافظة المرخصة",
        key: "name_ar",
      },
      area: {
        label: "المنطقة",
        key: "name",
      },
      address: {
        label: "العنوان التفصيلي",
      },
    };
  },
  async created() {
    await this.getCentres();
  },
};
</script>
